// **************************************************
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import {
  ApiResponseTable,
  ApiResponseWithputPagingTable,
} from '../models/api-response-table';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { EntityDefin } from '../interfaces/entity-defin';
import { Router } from '@angular/router';
import { LoggerService } from 'src/app/services/logger.service';
import { TranslateService } from '@ngx-translate/core';
import { Field } from '../models/entity-defin';
import * as Interfaces from '../interfaces/login';
import { LoginResponse } from 'src/app/auth/interfaces/login-response';
import { LastActivePageService } from 'src/app/services/last-active-page.service';
import { ReturnModalComponent } from '../components/return-modal/return-modal.component';
// **************************************************

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  public constructor(
    private http: HttpClient,
    private router: Router,
    private lastActivePageService: LastActivePageService,
    public logger: LoggerService,
    private translate: TranslateService
  ) {
    this.initMainUrl();
  }

  // public mainUrls: string[] = [
  //   `http://192.168.0.105:8090`,
  //   `http://localhost:5159`,
  // ];
  // public mainUrl: string = this.mainUrls[1];
  
  // private async setMainUrl(): Promise<void> {
  //   for (const url of this.mainUrls) {
  //     try {
  //       await fetch(`${url}/ping`, { method: 'GET' });
  //       this.mainUrl = url;
  //       break;
  //     } catch (e) {}
  //   }
  // }
  
  public mainUrl: string = `http://192.168.0.105:8090`;
  // public mainUrl: string = `http://localhost:5159`;
  private initMainUrl(): void {
    var thisHostName = window.location.hostname;
    if (thisHostName.indexOf('pendar') >= 0) {
      this.mainUrl = `https://api.pendarpharma.com`;
    }
    // this.setMainUrl().then(() => {
    //   console.log('Base URL set to:', this.mainUrl);
    // });
  }

  public mainTaminUrl: string = `https://darmanapi.tamin.ir`;

  public getToken(login: Interfaces.Login): Observable<LoginResponse> {
    let culture = this.translate.currentLang;
    if (culture == 'fa') {
      culture = 'fa-IR';
    } else {
      culture = 'en-US';
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        culture: culture,
      }),
    };

    let data = { username: login.username, password: login.password };
    let url = `${this.mainUrl}/Account/login`;

    return this.http.post<LoginResponse>(url, login, httpOptions).pipe();
  }

  public getAll(apiRequest: ApiRequestModel): Observable<ApiResponseTable> {
    let culture = this.translate.currentLang;
    if (culture == 'fa') {
      culture = 'fa-IR';
    } else {
      culture = 'en-US';
    }

    let finalUrl = `${this.mainUrl}/${apiRequest.url}`;

    this.tokenValidation(apiRequest);

    const headers = {
      Authorization: `Bearer ${apiRequest.token}`,
      culture: culture,
    };

    this.logger.addRequestLog(headers, apiRequest, finalUrl, `getAll`);

    return this.http.get<ApiResponseTable>(finalUrl, { headers }).pipe();
  }

  public getAllWithFilter(
    apiRequest: ApiRequestModel,
    filters: any
  ): Observable<ApiResponseTable> {
    let culture = this.translate.currentLang;
    if (culture == 'fa') {
      culture = 'fa-IR';
    } else {
      culture = 'en-US';
    }

    let finalUrl = `${this.mainUrl}/${apiRequest.url}`;

    this.tokenValidation(apiRequest);

    const headers: { [key: string]: string } = {
      Authorization: `Bearer ${apiRequest.token}`,
      culture: culture,
    };

    if (filters && typeof filters === 'object') {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          headers[key] = value.toString();
        }
      });
    }

    this.logger.addRequestLog(headers, apiRequest, finalUrl, `getAll`);

    return this.http.get<ApiResponseTable>(finalUrl, { headers }).pipe();
  }

  public getJson(apiRequest: ApiRequestModel): Observable<any> {
    let finalUrl = `${apiRequest.url}`;

    return this.http.get(finalUrl).pipe();
  }

  public getWhitoutToken(
    apiRequest: ApiRequestModel
  ): Observable<ApiResponseTable> {
    let culture = this.translate.currentLang;
    if (culture == 'fa') {
      culture = 'fa-IR';
    } else {
      culture = 'en-US';
    }

    let finalUrl = `${this.mainUrl}/${apiRequest.url}`;

    this.tokenValidation(apiRequest);

    const headers = {
      Authorization: `Bearer ${apiRequest.token}`,
      culture: culture,
    };
    this.logger.addRequestLog(headers, apiRequest, finalUrl, `getWhitoutToken`);

    return this.http.get<ApiResponseTable>(finalUrl).pipe();
  }

  public postWhitoutToken(
    apiRequest: ApiRequestModel
  ): Observable<ApiResponseTable> {
    let culture = this.translate.currentLang;
    if (culture == 'fa') {
      culture = 'fa-IR';
    } else {
      culture = 'en-US';
    }

    let finalUrl = `${this.mainUrl}/${apiRequest.url}`;

    this.tokenValidation(apiRequest);

    const headers = {
      Authorization: `Bearer ${apiRequest.token}`,
      culture: culture,
    };

    this.logger.addRequestLog(
      headers,
      apiRequest,
      finalUrl,
      `postWhitoutToken`
    );

    return this.http.post<ApiResponseTable>(finalUrl, apiRequest.body).pipe();
  }

  public getWitoutPage(
    apiRequest: ApiRequestModel
  ): Observable<ApiResponseWithputPagingTable> {
    let culture = this.translate.currentLang;
    if (culture == 'fa') {
      culture = 'fa-IR';
    } else {
      culture = 'en-US';
    }
    let finalUrl = `${this.mainUrl}/${apiRequest.url}`;

    this.tokenValidation(apiRequest);

    const headers = {
      Authorization: `Bearer ${apiRequest.token}`,
      culture: culture,
    };

    this.logger.addRequestLog(headers, apiRequest, finalUrl, `getWitoutPage`);

    return this.http
      .get<ApiResponseWithputPagingTable>(finalUrl, { headers })
      .pipe();
  }

  public getSingleItem(apiRequest: ApiRequestModel): Observable<any> {
    let finalUrl = `${this.mainUrl}/${apiRequest.url}`;
    let culture = this.translate.currentLang;
    if (culture == 'fa') {
      culture = 'fa-IR';
    } else {
      culture = 'en-US';
    }

    const headers = {
      Authorization: `Bearer ${apiRequest.token}`,
      culture: culture,
    };

    this.tokenValidation(apiRequest);

    this.logger.addRequestLog(headers, apiRequest, finalUrl, `getSingleItem`);

    return this.http.get<any>(finalUrl, { headers }).pipe();
  }

  public deleteItem(apiRequest: ApiRequestModel): Observable<any> {
    let finalUrl = `${this.mainUrl}/${apiRequest.url}`;

    let culture = this.translate.currentLang;
    if (culture == 'fa') {
      culture = 'fa-IR';
    } else {
      culture = 'en-US';
    }

    const headers = {
      Authorization: `Bearer ${apiRequest.token}`,
      culture: culture,
    };

    this.tokenValidation(apiRequest);

    this.logger.addRequestLog(headers, apiRequest, finalUrl, `deleteItem`);

    return this.http.delete<string>(finalUrl, { headers });
  }

  public postItem(apiRequest: ApiRequestModel): Observable<any> {
    let finalUrl = `${this.mainUrl}/${apiRequest.url}`;

    this.tokenValidation(apiRequest);

    let culture = this.translate.currentLang;
    if (culture == 'fa') {
      culture = 'fa-IR';
    } else {
      culture = 'en-US';
    }

    const headers = {
      Authorization: `Bearer ${apiRequest.token}`,
      culture: culture,
    };

    this.logger.addRequestLog(headers, apiRequest, finalUrl, `postItem`);

    return this.http.post(finalUrl, apiRequest.body, { headers });
  }

  public patchItem(apiRequest: ApiRequestModel): Observable<any> {
    let finalUrl = `${this.mainUrl}/${apiRequest.url}`;

    this.tokenValidation(apiRequest);

    let culture = this.translate.currentLang;
    if (culture == 'fa') {
      culture = 'fa-IR';
    } else {
      culture = 'en-US';
    }

    const headers = {
      Authorization: `Bearer ${apiRequest.token}`,
      culture: culture,
    };
    this.logger.addRequestLog(headers, apiRequest, finalUrl, `patchItem`);

    return this.http.patch<string>(finalUrl, apiRequest.body, { headers });
  }

  public getEntity(apiRequest: ApiRequestModel): Observable<any> {
    if (apiRequest.controllerName == null || apiRequest.controllerName == '') {
      apiRequest.controllerName == apiRequest.url;
    }

    let finalUrl = `${this.mainUrl}/EntityDefinition?endPoint=${apiRequest.controllerName}`;

    if (apiRequest.viewModelName != null && apiRequest.viewModelName != '') {
      finalUrl += `&viewModel=${apiRequest.viewModelName}`;
    }

    this.tokenValidation(apiRequest);

    let culture = this.translate.currentLang;
    if (culture == 'fa') {
      culture = 'fa-IR';
    } else {
      culture = 'en-US';
    }

    const headers = {
      Authorization: `Bearer ${apiRequest.token}`,
      culture: culture,
    };

    this.logger.addRequestLog(headers, apiRequest, finalUrl, `getEntity`);

    return this.http.get<EntityDefin[]>(finalUrl, { headers }).pipe();
  }

  public generateUrl(urlRequest: string): string {
    return `${this.mainUrl}/Entitydefin?orderBy=&direction=&page=0&size=1000&paginate=false&search=endpoint:${urlRequest}`;
  }

  public generateUrlAll(): string {
    return `${this.mainUrl}/Entitydefin?orderBy=&direction=&page=0&size=1000&paginate=false&search=`;
  }

  public tokenValidation(apiRequest: ApiRequestModel): boolean {
    if (apiRequest.url.indexOf('Userent') < 0) {
      if (
        apiRequest.token == null ||
        apiRequest.token == '' ||
        apiRequest.token == 'UNAUTHORIZED'
      ) {
        //this.router.navigate(["login"]);
        return false;
      }
    }
    return true;
  }

  public uploadFile(apiRequest: ApiRequestModel, file: File) {
    this.tokenValidation(apiRequest);

    let finalUrl = `${this.mainUrl}/${apiRequest.url}`;

    let culture = this.translate.currentLang;
    if (culture == 'fa') {
      culture = 'fa-IR';
    } else {
      culture = 'en-US';
    }

    const headers = {
      Authorization: `Bearer ${apiRequest.token}`,
      culture: culture,
    };

    const formData: FormData = new FormData();

    formData.append('file', file);

    this.logger.addRequestLog(headers, apiRequest, finalUrl, `Upload File`);

    return this.http.post<any>(finalUrl, formData, { headers }).pipe();
  }

  public generateFileUrl(fileName: string) {
    return `${this.mainUrl}/File/downloadFile/${fileName}`;
  }

  public GetTaminTocken(
    verifyCode: string,
    redirect_uri: string
  ): Observable<any> {
    let finalUrl = `https://account-pilot.tamin.ir/auth/server/token`;

    const body = new HttpParams()
      .set('code', verifyCode)
      .set('code_verifier', 'p1yg0k7gskwaphjla0zqysnf9sy3g8m7iqavjso5pwc')
      .set('grant_type', 'authorization_code')
      .set('client_id', '52325a1054023d5b2940111d541e2823')
      .set('redirect_uri', redirect_uri);

    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };

    return this.http.post(finalUrl, body, { headers });
  }

  public PostTaminPrescription(
    url: string,
    body: any,
    token: string
  ): Observable<any> {
    const finalUrl = `${this.mainTaminUrl}/${url}`;

    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      Referer: 'hosseinkalanaki.ir',
      'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
    };

    return this.http.post(finalUrl, body, { headers });
  }

  public AddErrorLog(error: any) {
    switch (error.status) {
      case 405: // Request not allowed or doesn't has access to backend
        this.logger.addError(
          this.translate
            .instant('REQUEST_NOT_ALLOWED')
            .replace('{0}', error.url),
          false
        );
        break;

      case 404: // Request not allowed or doesn't has access to backend
        this.logger.addError(
          this.translate
            .instant('REQUEST_NOT_ALLOWED')
            .replace('{0}', error.url),
          false
        );
        break;

      case 440: // Access Denied
        this.lastActivePageService.storeLastActivePage(this.router.url);
        this.router.navigateByUrl(`/login`);
        setTimeout(() => {
          location.reload();
        }, 2);
        break;

      case 0: // Request Failed
        this.logger.addError(
          this.translate.instant('REQUEST_FAILED').replace('{0}', error.url),
          false
        );
        break;

      case 400: // REQUEST_NOT_ALLOWED
        if (error.error.errorMessages != undefined) {
          this.logger.addListError(error.error.errorMessages);
        } else {
          this.logger.addError(
            this.translate
              .instant('REQUEST_NOT_ALLOWED')
              .replace('{0}', error.url),
            false
          );
        }
        break;

      default:
        if (error.error.errorMessages != undefined) {
          this.logger.addListError(error.error.errorMessages);
        } else {
          this.logger.addError('ConnectionError', false);
        }
        break;
    }
  }

  public AddErrorLogItemAccess(error: any): boolean {
    switch (error.status) {
      case 405: // Request not allowed or doesn't has access to backend
        this.logger.addError(
          this.translate
            .instant('REQUEST_NOT_ALLOWED')
            .replace('{0}', error.url),
          false
        );

        return true;

      case 404: // Request not allowed or doesn't has access to backend
        this.logger.addError(
          this.translate
            .instant('REQUEST_NOT_ALLOWED')
            .replace('{0}', error.url),
          false
        );

        return true;

      case 440: // Access Denied
        return false;

      case 0: // Request Failed
        this.logger.addError(
          this.translate.instant('REQUEST_FAILED').replace('{0}', error.url),
          false
        );
        return true;

      case 400: // REQUEST_NOT_ALLOWED
        if (error.error.errorMessages != undefined) {
          this.logger.addListError(error.error.errorMessages);
        } else {
          this.logger.addError(
            this.translate
              .instant('REQUEST_NOT_ALLOWED')
              .replace('{0}', error.url),
            false
          );
        }
        return true;

      default:
        if (error.error.errorMessages != undefined) {
          this.logger.addListError(error.error.errorMessages);
        } else {
          this.logger.addError('ConnectionError', false);
        }
        return true;
    }
  }

  public convertStringToBoolean(fields: any[]): Field[] {
    try {
      for (let thisItem of fields) {
        if (thisItem.fieldType == 'Boolean' && thisItem.defaultValue == null) {
          thisItem.defValue = false;
        }
      }
    } catch (error) {
      this.logger.addError(error, false);
    }
    return fields;
  }

  public camelCase(value: string) {
    if (value == 'LOT') {
      return 'lot';
    }
    // Using replace method with regEx
    return value
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index == 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, '');
  }

  public fixImage(imagePath: string | undefined): string | undefined {
    if (imagePath == null) {
      return undefined;
    }
    return `${this.mainUrl}${imagePath}`;
  }
}
